var $e03903e9a2e8a8dc$exports = {};
$e03903e9a2e8a8dc$exports = {
    "clear": `Vymazat`,
    "invalid": `(neplatn\xe9)`,
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "noResults": `\u{17D}\xe1dn\xe9 v\xfdsledky`,
    "valid": `(platn\xe9)`
};


export {$e03903e9a2e8a8dc$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
